import classNames from 'classnames/bind';
import React from 'react';

import { withFormsy } from 'formsy-react';
import { Tag, Icon } from '../base/Elements';
import { i18n } from 'common';


class _AdminIconPicker extends React.Component {
  state = {current: null}

  onClick = (ev) => {
    const value = ev.currentTarget.getAttribute('data-value');

    this.props.setValue(value);
    this.setState({current: value});
  }

  render() {
    const current = this.state.current || this.props.value;
    const isPristine = this.props.isPristine();
    const hasErrors = !isPristine && this.props.showError();
    const errorMessage = this.props.getErrorMessage();

    return (
      <div className={classNames({'f-error': hasErrors})}>
        {this.props.items.map((item, index) => (
          <Tag onClick={this.onClick} data-value={item} key={index} color={current === item ? "orange" : "gray"} className="mrb05 tag--toggle is-clickable">
            <Icon src={item} className="mr05" />
            <span>{item}</span>
          </Tag>
        ))}

        {hasErrors &&
          <ul className="f-error-message">
            <li>{errorMessage}</li>
          </ul>
        }
      </div>
    );
  }
};

export const AdminIconPicker = withFormsy(_AdminIconPicker);
